module.exports = __webpack_public_path__ + "media/images/fbcalls/recomendacao-b2dbc082ed8456d088dac097affa6917.png";